import {Outlet} from "react-router-dom";
import ScrollToTop from "../../util/ScrollToTop";
import React, {useEffect} from "react";
import {lazyLoadClarity, lazyLoadFacebookPixel, lazyLoadTikTokPixel} from "../../util/LazyLoadScripts";

export default function FunnelRootLayout() {
    // Google Ads is intentionally disabled on EAS — launch with Meta-only paid traffic.
    // The previous PageView/consent-grant hooks are removed; gtag isn't loaded on this
    // domain. Re-add them when GAds is brought online.

    useEffect(() => {
        // Lazy load Facebook Pixel to avoid blocking initial render
        const initPixel = async () => {
            try {
                const ReactPixel = await lazyLoadFacebookPixel();
                ReactPixel.init(process.env.REACT_APP_FB_PIXEL_ID, undefined, {debug: false, autoConfig: true});
                ReactPixel.pageView();
            } catch (error) {
                console.error('Failed to load Facebook Pixel:', error);
            }
        };

        // Delay initialization to prioritize critical resources
        setTimeout(initPixel, 100);

        // Lazy load Clarity for analytics
        lazyLoadClarity('os3zpotjsv');

        // Lazy load TikTok Pixel for analytics
        lazyLoadTikTokPixel('D43I7ABC77U4N81AOIJG');
    }, []);

    return <>
        <ScrollToTop/>
        <Outlet/>
    </>
}